import { Chip } from '@mui/material';
import {
  OrderInsightDeflectionOutcome,
  OrderInsightDeflectionOutcomeLabel,
  deflectionOutcome,
} from "../../types/verifiOrderInsight";

const DEFLECTION_COLOR: Record<OrderInsightDeflectionOutcome, 'success' | 'error'> = {
  deflected: 'success',
  failed: 'error',
};

export default function DeflectionChip({ caseEvent }: { caseEvent: string | null }) {
  const outcome = deflectionOutcome(caseEvent);
  if (!outcome) return <>--</>;
  return (
    <Chip
      label={OrderInsightDeflectionOutcomeLabel[outcome]}
      color={DEFLECTION_COLOR[outcome]}
      size="small"
      variant="outlined"
    />
  );
}
